import { Tabs } from "layout";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InqFollowUps from "./InqFollowUps";
import { action, API, controller } from "api";
import InqDetails from "./InqDetails";
import { AppContext } from "App";

const ViewInquiry = () => {
  const { access } = useContext(AppContext);
  const { id } = useParams();
  const [values, setValues] = useState({});

  useEffect(() => {
    id &&
      API(controller.Inquiry + action.GetById).getById(id, (res) => {
        if (res && res.status === 200) setValues((x) => ({ ...res.result }));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <Tabs header={[{ label: "Details" }, { label: "Follow Up" }]}>
        <InqDetails values={values} />
        {access?.inquery?.followUp ? (
          <InqFollowUps values={values} />
        ) : (
          "Don't have access to follow up"
        )}
      </Tabs>
    </>
  );
};

export default ViewInquiry;
